import { Component, OnInit, OnChanges, SimpleChanges, Inject, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpAuth } from '../../services/http-auth.service';
import { JobOffersService } from '../../services/job-offers.service';
import { JobsOffer } from '../../models/jobs-offer';
import { MdDialog } from '@angular/material';
import { InviteService } from '../../services/invite.service';
import { CandidateService } from '../../services/candidate.service';
import { InviteComponent } from '../invite/invite.component';
import { ConfirmDeleteDialogComponent } from '../confirm-delete-dialog/confirm-delete-dialog.component';
import { environment } from '../../../environments/environment';
// import { IMyOptions, IMyDateModel } from 'mydatepicker';
import { Event } from '../../models/event';
import { EventService } from '../../services/event.service';
import { ReminderService } from '../../services/reminder.service';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { TypeEventService } from '../../services/type-event.service';
import * as esLocale from "date-fns";
import { FullProfileService } from '../../services/full-profile.service';
import { ConfigurationService } from '../../services/configuration.service';

@Component({
  selector: 'app-view-event',
  templateUrl: './view-event.component.html',
  styleUrls: ['./view-event.component.css'],
})
export class ViewEventComponent implements OnInit {

  jobId: string;
  userId: string;
  job: JobsOffer;
  user: string;
  viewevent: boolean;
  event: any;
  dateandtime: any;

  errorMessage: string;
  initialized: boolean;

  loading: boolean;
  publicating: boolean;
  private landing = `${ environment.landing }`;
  es: any;
  date: Date;
  time: Date;

  typeEventList: any;

  constructor(
    private route: ActivatedRoute,
    private jobService: JobOffersService,
    private _router: Router,    private dialog: MdDialog,
    private inviteService: InviteService,
    public candidateService: CandidateService,
    public eventService: EventService,
    public reminderService: ReminderService,
    public typeEventService: TypeEventService,
    public fullProfileService: FullProfileService,
    private configurationService: ConfigurationService
  ) {
    this.es = {
      firstDayOfWeek: 1,
      dayNames:["domingo","lunes","martes","miércoles","jueves","viernes","sábado" ],
      dayNamesShort: [ "dom","lun","mar","mié","jue","vie","sáb" ],
      monthNames: [ "enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre" ],
      monthNamesShort: [ "ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic" ],
      dateFns: esLocale
    };
  }

  ngOnInit() {
    // TODO: get users invite to jobId
    this.loading = true;
    this.publicating = false;
    this.date = new Date();
    this.date.setHours(13, 0);

    this.time = new Date();
    this.time.setHours(13, 0);

    this.dateandtime = this.date;

    this.getTypeEventList();
    this.initEvent();

    this.configurationService.configuration$.subscribe(
      response => {
        if (response) {
          this.refreshConfiguration();
        } else {
          this.user = '';
        }
        // this.dialog.open(MessageBoxDialog, {data: {message: "No se pudo conectar con el servidor, Problemas de conexión con internet", success:true, showIcon:true}});
      }
    );

    this.route.params.subscribe(params => {
      this.jobId = params['jobId'];
      this.userId = params['userId'];
      if (typeof this.jobId != 'undefined') {
        this.initEvent(this.jobId, this.userId);
        if (typeof this.userId != 'undefined') {
            this.fullProfileService.getProfile(this.userId, this.jobId).subscribe(
            data => {
              this.user = data.firstname + ' ' + data.lastname;
            },
            error => {
              this.errorMessage = <any>error;
            }
          );
        }

        this.jobService.getOffersById(this.jobId).subscribe(
          data => {
            this.job = data;
            this.loading = false;
          },
          error => {
            this.errorMessage = <any>error;
            this.loading = false;
          }
        );
        this.initialized = true;
      } else {
        this.user = localStorage.getItem('name');
        this.loading = false;
      }
    });
  }

  refreshConfiguration() {
    if (localStorage.getItem('name')) {
      this.user = localStorage.getItem('name');
    } else {
      this.user = '';
    }
  }

  public initEvent(jobId?: string, userId?: string) {
    this.event = {
      jobid: '',
      userid: '',
      type: 1,
      details: '',
      dateandtime: this.date
    };

    if (jobId) {
      this.event.jobid = jobId;
    }

    if (userId) {
      this.event.userid = userId;
    }
  }

  private yesterday() {
    let currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - 1);

    return currentDate;
  }

  onDateChanged($event) {
    this.event.dateandtime = $event.formatted;
  }

  openDialogInvite(job) {
    let dialogRef = this.dialog.open(InviteComponent);
    dialogRef.componentInstance.createInvite=true;
    dialogRef.componentInstance.Job=job;
    dialogRef.componentInstance.nameComponent='Invitación';
    dialogRef.afterClosed().subscribe(result => {
      if (result != "YES") {
      }
    });
  }

  openDialogDelete(job,status) {
      let dialogRef = this.dialog.open(ConfirmDeleteDialogComponent);
      dialogRef.componentInstance.deleteOffer=true;
      dialogRef.componentInstance.OfferID=job.id;
      dialogRef.componentInstance.OfferStatus=status;
      dialogRef.afterClosed().subscribe(result => {
        if (result != "NO")
          job.status = -6;
      });
  }

  putOffersStatus(job, status) {
    this.jobService.putOffersStatus(job.id, status)
      .subscribe(
        data => {
        },
        error => this.errorMessage = <any>error
      );
  }

  cloneJob(jobId) {
    this._router.navigate(['/createoffer', jobId]);
  }

  viewJob(jobId) {
    this._router.navigate(['/viewoffer', jobId]);
  }

  viewJobKanban(jobId) {
    this._router.navigate(['/viewjob', jobId]);
  }

  gotoLanding (jobId) {
    window.open(this.landing + jobId, '_blank');
  }

  getTypeEventList () {
    this.typeEventList = [];
    this.typeEventService.getTypeEventList(1, 1000)
    .subscribe(
      data => {
        this.typeEventList = data.eventtype;
      },
      error => {
      }
    );
  }

  onPostEvent() {
    this.publicating = true;
    const month = this.date.getMonth() + 1;
    const a = this.date.getFullYear() + '-' + month + '-' + this.date.getDate() + ' ' + this.time.getHours() +
    ':' + this.time.getMinutes() + ':00:00';
    this.event.dateandtime = new Date (a);
    this.eventService.postEvent(this.event)
    .subscribe(
      data => {
        this.publicating = false;
        this.dialog.open(MessageBoxDialog, {data: {message: 'Evento Creado', success: true, showIcon:true}});
        this.initEvent(this.jobId, this.userId);
        this.eventService.publish();
      },
      error => {
        this.dialog.open(MessageBoxDialog, {data: {title: 'No se pudo crear el Evento', message: 'Verifique los datos del evento', alert: true, showIcon:true}});
        this.publicating = false;
      }
    );
  }

  onPostReminder() {
    this.publicating = true;
    const month = this.date.getMonth() + 1;
    const a = this.date.getFullYear() + '-' + month + '-' + this.date.getDate() + ' ' + this.time.getHours() +
    ':' + this.time.getMinutes() + ':00:00';
    this.event.dateandtime = new Date (a);
    this.reminderService.postReminder(this.event)
    .subscribe(
      data => {
        this.publicating = false;
        this.dialog.open(MessageBoxDialog, {data: {message: 'Recordatorio Creado', success: true, showIcon:true}});
        this.eventService.publish();
        this.initEvent();
      },
      error => {
        this.dialog.open(MessageBoxDialog, {data: {title: 'No se pudo crear el Recordatorio', message: 'Verifique los datos del recordatorio', alert: true, showIcon:true}});
        this.publicating = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/view-event/view-event.component.ts